/*
 * Boutique of Pashtuns — About Us page interactions.
 * Scoped entirely to elements this section renders; loaded only on the
 * About Us template. Two independent, optional behaviors:
 *   1. Count-up on the primary statistic (data-about-us-count)
 *   2. Then & Now drag/touch/keyboard comparison slider (data-about-us-compare)
 * Both respect prefers-reduced-motion and both leave the correct final
 * value/state in the DOM even if JS never runs.
 */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCountUp() {
    var els = document.querySelectorAll('[data-about-us-count="true"]');
    if (!els.length) return;

    els.forEach(function (el) {
      var finalText = el.getAttribute('data-count-value') || el.textContent;
      var match = finalText.match(/[\d,]+/);

      if (prefersReducedMotion || !match || !('IntersectionObserver' in window)) {
        el.textContent = finalText;
        return;
      }

      var target = parseInt(match[0].replace(/,/g, ''), 10);
      if (isNaN(target)) {
        el.textContent = finalText;
        return;
      }

      var prefix = finalText.slice(0, match.index);
      var suffix = finalText.slice(match.index + match[0].length);
      var configuredDuration = parseInt(el.getAttribute('data-count-duration'), 10);
      var duration = isNaN(configuredDuration) ? 1600 : configuredDuration;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);

          var start = null;

          function step(timestamp) {
            if (!start) start = timestamp;
            var progress = Math.min((timestamp - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.floor(eased * target).toLocaleString('en-IN');
            el.textContent = prefix + current + suffix;
            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              el.textContent = finalText;
            }
          }

          window.requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });

      observer.observe(el);
    });
  }

  function initCompareSliders() {
    var boxes = document.querySelectorAll('[data-about-us-compare]');
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      var handle = box.querySelector('.about-us__compare-handle');
      if (!handle) return;

      var pct = 50;
      var dragging = false;

      function set(value) {
        pct = Math.max(0, Math.min(100, value));
        box.style.setProperty('--split', pct + '%');
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }

      function fromEvent(event) {
        var rect = box.getBoundingClientRect();
        var clientX = event.touches ? event.touches[0].clientX : event.clientX;
        set(((clientX - rect.left) / rect.width) * 100);
      }

      function start(event) {
        dragging = true;
        fromEvent(event);
      }

      function move(event) {
        if (dragging) fromEvent(event);
      }

      function end() {
        dragging = false;
      }

      box.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      box.addEventListener('touchstart', start, { passive: true });
      box.addEventListener('touchmove', move, { passive: true });
      box.addEventListener('touchend', end);

      handle.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          set(pct - 4);
          event.preventDefault();
        } else if (event.key === 'ArrowRight') {
          set(pct + 4);
          event.preventDefault();
        }
      });

      set(50);
    });
  }

  function init() {
    initCountUp();
    initCompareSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-about-us-compare], [data-about-us-count]')) {
        initCountUp();
        initCompareSliders();
      }
    });
  }
})();
